import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import SaveButtonWithModal from "../SaveButtonWithModel";
import { uploadToCloudinary } from "../../utils/CloudinaryUpload";

const OrganizationForm = ({
  formData,
  onFormDataChange,
  selectedOption,
  onCertificatesUrlChange, // ADD THIS
  onIdUrlChange,
  onOptionChange,
  onSave,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCircles, setSelectedCircles] = useState({});
  const [images, setImages] = useState(Array(12).fill(null));
  const [certFiles, setCertFiles] = useState(Array(12).fill(null));

  const [showModal, setShowModal] = useState(false);
  const [idFile, setIdFile] = useState(null);
  const [idImageUrl, setIdImageUrl] = useState(null);
  const [saving, setSaving] = useState(false); // for upload
  const [error, setError] = useState(""); // Error state for required certificates

  const toggleCircle = (item) => {
    setSelectedCircles((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleOptionClick = (option) => {
    onOptionChange(option);
    setIsOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    onFormDataChange({ ...formData, [name]: value });
  };
  const documentTitles = [
    "Directors ID (certified)",
    "CK document (certified)",
    "Tax Clearance",
    "Bank Confirmation Letter",
    "BEE /Sworn Affidavit (certified)",
    "EIA",
    "Company Profile",
    "CSD",
    "Lease Agreement",
    "Land Ownership / title   deed ",
    "Document",
    "Document",
  ];

  const handleDeleteImage = (index) => {
    setImages((prevImages) => {
      if (!prevImages[index]) return prevImages;
      const newImages = [...prevImages];
      newImages[index] = null;
      return newImages;
    });
    setCertFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles[index] = null;
      return newFiles;
    });
  };

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate a preview URL
      setImages((prevImages) => {
        const newImages = [...prevImages];
        newImages[index] = imageUrl; // Store preview URL for display
        return newImages;
      });
      setCertFiles((prevFiles) => {
        const newFiles = [...prevFiles];
        newFiles[index] = file; // Store the file for upload
        return newFiles;
      });
    }
  };

  const handleIdChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setIdFile(file); // Store the file for upload
      setIdImageUrl(URL.createObjectURL(file)); // Generate a preview URL for display
    }
  };

  // Save handler: upload images, then call onSave with URLs included!
  const handleSave = async () => {
    const hasCertificates = certFiles.some((file) => file !== null);
  
    if (!hasCertificates) {
      setError("At least one certificate is required.");
      setShowModal(false); // Don't show modal if error
      return;
    }
  
    setError("");
    setSaving(true);
    let certUrls = [];
    let idUrl = "";
  
    // Upload certificates files to Cloudinary
    for (let i = 0; i < certFiles.length; i++) {
      if (certFiles[i]) {
        const url = await uploadToCloudinary(certFiles[i]); // Upload each file
        certUrls.push(url);
      }
    }
  
    if (onCertificatesUrlChange) onCertificatesUrlChange(certUrls); // Pass URLs up
    if (certUrls.length) {
      console.log("Certificates URLs:", certUrls); // Log uploaded URLs
    }
  
    // Upload ID doc to Cloudinary
    if (idFile) {
      idUrl = await uploadToCloudinary(idFile); // Upload the ID document
      if (onIdUrlChange) onIdUrlChange(idUrl);
      if (idUrl) {
        console.log("ID Document URL:", idUrl); // Log uploaded ID URL
      }
    }
  
    setSaving(false);
    setShowModal(true);
  
    // Pass all data to the parent component
    onSave({
      ...formData,
      certificates: certUrls, // Include certificate URLs
      idDocument: idUrl,      // Include ID document URL
      typeOfOrganization: selectedOption,
    });
  };
  return (
    <div className="md:px-0 md:mt-6">
      <div className="">

        <div className=" mb-6">
          <label className="block text-[8px] md:text-[36px] font-bold mb-3 leading-[1.25]">
            Documents / Certificates{" "}
            <p className="font-normal italic text-[6px] md:text-[24px]">
              Please insert certificates
            </p>
          </label>


        </div>
        <div className="grid grid-cols-4 md:gap-2 gap-1 mb-6">
          {images.slice(0, 12).map((imgSrc, index) => (
            <div key={index} className="flex flex-col  md:mt-6">
              <p className="text-[6px] md:text-[24px] font-light italic text-left mb-2 min-h-[12px] md:w-[260px]  leading-tight md:min-h-[60px]">
                {documentTitles[index]}
              </p>


              <div className="relative bg-[#D9D9D9] rounded-[5px] h-[85px]  md:h-[350px] w-full overflow-hidden">
                {imgSrc && (
                  <img
                    src={imgSrc}
                    alt="Certificate"
                    className="object-cover w-full h-full"
                  />
                )}

                <label className="absolute top-1 right-1 md:top-3 md:right-3 cursor-pointer">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745668623/Add_square_duotone_gz7vxe.png"
                    alt="Add Icon"
                    className="md:flex hidden w-6 md:w-[40px] h-6 md:h-[40px]"
                  />
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745695620/Add_square_duotone_1_budndy.png"
                    alt="Add Icon"
                    className="md:hidden flex w-4 md:w-[40px] h-4 md:h-[40px]"
                  />
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageChange(e, index)}
                    className="hidden"
                  />
                </label>

                <div className="absolute md:bottom-2 md:right-2 bottom-1 right-1">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746296659/Trash_ya7kiu.png"
                    alt="Trash Icon"
                    className="md:flex hidden w-3 md:w-[24px] h-3 md:h-[24px] cursor-pointer"
                    onClick={() => handleDeleteImage(index)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ID upload section */}
      </div>

      {/* Error message for certificates */}
      {error && (
        <div className="mt-2 text-red-600 text-xs text-center">{error}</div>
      )}

      {/* Save Button */}
      <SaveButtonWithModal onClick={handleSave} loading={saving} />

      {/* Save Modal */}
      {showModal && !error && (
        <SaveButtonWithModal
          isOpen={showModal}
          onRequestClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default OrganizationForm;